import {FormGroup} from "@angular/forms";
import {
  BmAnalyticsBarCharts,
  BmAnalyticsBarData,
  BmAnalyticsDataFg,
  BmAnalyticsPieData
} from "../../../pojo/bm-form";
import {
  BmAnalyticsBarTypes,
  BmAnalyticsChartData,
  BmAnalyticsChartsOptions,
} from "../../../pojo/bm-analytics-classes";
import {
  CHART_COLORS,
  CHART_STYLES, formatNumberWithSuffix,
} from "../../../../../shared/component/highcharts-common/highcharts-global-const";

export class BmAnalyticsChartsService {

  public static createChartOptions(analyticsData: FormGroup<BmAnalyticsDataFg>): BmAnalyticsChartsOptions {
    return {
      bar: this.createBarChartsOptions(analyticsData.controls.barCharts),
      pie: this.createPieChartData(analyticsData.controls.pieCharts)
    };
  }

  private static createBarChartsOptions(barCharts: FormGroup<BmAnalyticsBarCharts>): BmAnalyticsBarTypes {
    return {
      capRequired: this.createBarChartData(barCharts.controls.capRequired),
      totalExp: this.createBarChartData(barCharts.controls.totalExp),
      investment: this.createBarChartData(barCharts.controls.investment),
      mgmFee: this.createBarChartData(barCharts.controls.mgmFee),
      opExp: this.createBarChartData(barCharts.controls.opExp),
      orgExp: this.createBarChartData(barCharts.controls.orgExp),
    };
  }

  private static createBarChartData(data: FormGroup<BmAnalyticsBarData>): BmAnalyticsChartData {
    return {
      chartId: data.value.chartId,
      additionalOptions: {
        chart: {
          type: 'line',
        },
        title: undefined,
        yAxis: {
          title: undefined,
        },
        tooltip: CHART_STYLES.customBmModelTooltip(2, data.value.budget),
        legend: CHART_STYLES.legendHidden,
        xAxis: {
          labels: {
            formatter(): string {
              return `Year ${this.value}`;
            },
          },
        },
        series: [
          {
            name: 'Budget',
            data: data.value.budget.map((item) => [item[0], item[1]]),
            color: CHART_COLORS.black9,
            dashStyle: 'ShortDash',
            marker: {
              enabled: false,
            },
          },
        ],
      },
    };
  }

  private static createPieChartData(data: FormGroup<BmAnalyticsPieData>): BmAnalyticsChartData {
    return {
      chartId: data.value.chartId,
      additionalOptions: {
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              useHTML: true,
              distance: 30,
              formatter(): string {
                return `
                <div style="text-align: left">
                  <div style="font-size: 0.75rem; padding-bottom: 0.5rem;"><span style="color: ${this.color};">●</span> ${this.key}</div>
                  <div style="font-size: 1rem; font-weight: bold; color: #263238;">${formatNumberWithSuffix(this.y, 1)}</div>
                  <div style="font-size: 0.8rem; color: #999">${this.percentage.toFixed(2)}%</div>
                </div>
              `;
              },
            },
            size: '70%',
            states: CHART_STYLES.pieChartStates,
          },
        },
        series: [{
          name: 'Value',
          data: data.value.series,
        }],
      },
    };
  }
}
